import { useContext } from 'react';

import NewsContext from './news.context';

function useNews() {
  const context = useContext(NewsContext);

  if (!context) {
    throw new Error('useNews must be used within NewsContext');
  }

  return context;
}

export default useNews;